import { store, onChange } from 'store';
import uniqBy from 'lodash.uniqby';
import eventEmitter from '../eventEmitter/EventEmitter';
import basketService from '../services/BasketService';
import mainRepository from '../repositories/MainRepository';
import authService from '../services/AuthService';
import priceService from '../services/PriceService';
import { IStore } from '@/typings';
import eventTracker from '../eventTracker/EventTracker';

const mainStore: IStore = {
  store: store({
    baseUrl: '',
    xtoken: '',
    accessToken: '',
    refreshToken: '',
    clientSecret: '',
    clientId: '',
    env: null,
    prices: [],
  }),
  setHttpSettings: (data): void => {
    mainStore.store.baseUrl = data.baseUrl;
    mainStore.store.xtoken = data.xtoken;
  },
  setEnv: (data): void => {
    mainStore.store.env = data;

    basketService.initBasketService();
    basketService.initBasketService();
    authService.initAuthApi();
    priceService.initPriceService();
  },
  setAccessToken: (accessToken): void => {
    mainStore.store.accessToken = accessToken;
    mainRepository.setAccessToken(accessToken);
  },
  setRefreshToken: (refreshToken): void => {
    mainStore.store.refreshToken = refreshToken;
    mainRepository.setRefreshToken(refreshToken);
  },
  setPrices: async (ids, isRefresh = true): Promise<void> => {
    const newData = await priceService.getProducts(ids, isRefresh);

    mainStore.store.prices = uniqBy([...mainStore.store.prices, ...newData], 'id');

    eventTracker.dispatchEvent('price-updated', mainStore.store.prices);
  },

  logout: () => {
    mainStore.store.accessToken = '';
    mainStore.store.refreshToken = '';
    mainRepository.removeAccessToken();
    mainRepository.removeRefreshToken();
  },
};

export const initAccessTokens = (): void => {
  const accessToken = mainRepository.getAccessToken();
  const refreshToken = mainRepository.getRefreshToken();

  if (accessToken) {
    mainStore.setAccessToken(accessToken);
  }

  if (refreshToken) {
    mainStore.setRefreshToken(refreshToken);
  }
};

onChange(mainStore.store, (localStore: typeof mainStore.store): void => {
  eventEmitter.emit('main-store-changed', localStore);
});

onChange(
  mainStore.store,
  (localStore: typeof mainStore.store): any => localStore.prices,
  () => false,
  (prices) => {
    eventEmitter.emit('price-changed', prices);
  },
);

export default mainStore;
